"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Pavona",
  description: "Investimenti mirati per il decoro urbano, nuove aree verdi e il completamento delle infrastrutture viarie essenziali.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/pavona_urban_plan.png"
}, {
  title: "Cecchina",
  description: "Potenziamento dei collegamenti e nuovi spazi di aggregazione sociale per una frazione sempre più integrata e vivibile.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/cecchina_development.png"
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}